function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.592 17.67c0 .929-.368 1.564-1.592 1.564-1.224 0-1.592-.61-1.592-1.564v-.147c0-.953.368-1.588 1.592-1.588 1.224 0 1.592.635 1.592 1.588v.147zm-3.05-12.782h2.915v9.532h-2.914V4.888zM12 0C5.363 0 0 5.377 0 12s5.363 12 12 12 12-5.377 12-12S18.637 0 12 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,2.83333333 C6.93738979,2.83333333 2.83333333,6.93738979 2.83333333,12 C2.83333333,17.0626102 6.93738979,21.1666667 12,21.1666667 C17.0626102,21.1666667 21.1666667,17.0626102 21.1666667,12 C21.1666667,6.93738979 17.0626102,2.83333333 12,2.83333333 Z M12,16 C12.5128358,16 12.9355072,16.3827202 12.9932723,16.8826674 L13,17 C13,17.5128358 12.6172798,17.9355072 12.1173326,17.9932723 L12,18 C11.4871642,18 11.0644928,17.6172798 11.0067277,17.1173326 L11,17 C11,16.4871642 11.3827202,16.0644928 11.8826674,16.0067277 L12,16 Z M13,6 L13,14 L11,14 L11,6 L13,6 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.592 17.67c0 .929-.368 1.564-1.592 1.564-1.224 0-1.592-.61-1.592-1.564v-.147c0-.953.368-1.588 1.592-1.588 1.224 0 1.592.635 1.592 1.588v.147zm-3.05-12.782h2.915v9.532h-2.914V4.888zM12 0C5.363 0 0 5.377 0 12s5.363 12 12 12 12-5.377 12-12S18.637 0 12 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92 1 1 5.93 1 12C1 18.07 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM11 5H13V14H11V5ZM12 19C11.17 19 10.5 18.33 10.5 17.5C10.5 16.67 11.17 16 12 16C12.83 16 13.5 16.67 13.5 17.5C13.5 18.33 12.83 19 12 19Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9757C12.2891 17.9757 12.5314 17.8779 12.7269 17.6824C12.9225 17.4868 13.0202 17.2445 13.0202 16.9555C13.0202 16.6664 12.9225 16.4241 12.7269 16.2286C12.5314 16.033 12.2891 15.9353 12 15.9353C11.7109 15.9353 11.4686 16.033 11.2731 16.2286C11.0775 16.4241 10.9798 16.6664 10.9798 16.9555C10.9798 17.2445 11.0775 17.4868 11.2731 17.6824C11.4686 17.8779 11.7109 17.9757 12 17.9757ZM11.0527 13.3603H12.9473V5.78136H11.0527V13.3603ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM11.657 4C12.771 4 13.204 4.949 13.204 5.94C13.204 7.271 12.898 8.999 12.655 10.364C12.638 10.459 12.622 10.552 12.606 10.644L11.966 14.44H11.347L10.687 10.644C10.44 9.241 10.109 7.363 10.109 5.94C10.109 4.949 10.523 4 11.657 4ZM11.754 19.766C10.789 19.766 10 18.999 10 18.034C10 17.069 10.789 16.28 11.754 16.28C12.719 16.28 13.486 17.069 13.486 18.034C13.486 18.999 12.719 19.766 11.754 19.766Z",
    fill: "currentColor"
  }));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9997C0 5.37273 5.37232 0 12 0C18.6277 0 24 5.37273 24 12.0003C24 18.6273 18.6277 24 12 24C5.37232 24 0 18.6273 0 11.9997ZM11.7877 14.2827H12.2846C12.6895 14.2827 13.0391 13.9772 13.0575 13.6038L13.4992 7.6789C13.5176 7.30549 13.2048 6 12.7999 6H11.1987C10.8307 6 10.4994 7.27155 10.5178 7.66192L10.9963 13.5699C11.0147 13.9603 11.3828 14.2827 11.7877 14.2827ZM11.9915 18C12.826 18 13.4829 17.3294 13.4829 16.5C13.4829 15.6706 12.826 15.0001 11.9915 15.0001C11.157 15.0001 10.5 15.6706 10.5 16.5C10.5 17.3294 11.157 18 11.9915 18Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
import { ThemeContext } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = React.useContext(ThemeContext) || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.negative) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.negative;
  } else {
    switch (brand) {
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}